(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-upsells"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.cart-upsell-card__add[data-variant-id]').forEach(button => {
    button.addEventListener('click', async function(e) {
      e.preventDefault();
      if (this.disabled || this.classList.contains('is-loading')) return;

      const variantId = this.dataset.variantId;
      this.classList.add('is-loading');

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });

        if (!response.ok) throw new Error('Failed to add to cart');

        const sectionsToUpdate = document.querySelector('cart-items-component')?.dataset.sectionId;
        if (sectionsToUpdate) {
          const cartResponse = await fetch(window.Shopify.routes.root + '?sections=' + sectionsToUpdate);
          const sections = await cartResponse.json();

          const cartItemsComponent = document.querySelector('cart-items-component');
          if (cartItemsComponent && sections[sectionsToUpdate]) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(sections[sectionsToUpdate], 'text/html');
            const newContent = doc.querySelector('cart-items-component');
            if (newContent) {
              cartItemsComponent.innerHTML = newContent.innerHTML;
            }
          }
        }
      } catch (error) {
        console.error('Upsell add to cart error:', error);
      } finally {
        this.classList.remove('is-loading');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mc-shipping-note"] && !Shopify.designMode) return;
  try {
    /* Typical delivery time for the chosen country, from the shop metafield.
     Country line when the country has enough tracked deliveries, otherwise
     its zone's line and a note saying which zone. Choice remembered per
     browser; the duty sentence follows the chosen country too. */
  (function () {
    var EU = 'AT,BE,BG,CY,DK,EE,FI,LV,LU,MT,NL,PT,SK,ES,SE,FR,DE,IT,IE,HR,CZ,GR,HU,LT,PL,RO,SI,MC'.split(',');
    function zoneOf(cc) {
      if (cc === 'GB' || cc === 'IM' || cc === 'JE' || cc === 'GG') return 'uk';
      if (cc === 'US') return 'us';
      if (cc === 'AU' || cc === 'NZ') return 'anz';
      if (EU.indexOf(cc) !== -1) return 'eu';
      return 'world';
    }
    /* "to the United States", not "to United States" (English names only; other locales pass through) */
    var THE = /^(United|Netherlands|Philippines|Czech|Isle of|Channel|Bahamas|Maldives|Dominican|Falkland|Cayman|Faroe|Marshall|Solomon|Turks|Virgin|Gambia|Central African|Democratic|Republic)/;
    function withArticle(n) { return (document.documentElement.lang || 'en').slice(0, 2) === 'en' && THE.test(n) ? 'the ' + n : n; }
    function fill(t, vars) { return t.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) { return vars[k] != null ? vars[k] : m; }); }

    document.querySelectorAll('.mc-ship-note').forEach(function (note) {
      var dataEl = note.querySelector('.mc-ship-note__data');
      var sel = note.querySelector('.mc-ship-note__select');
      /* £250 free Special Delivery notice: server-rendered for UK, hidden here
         if the country picker is moved off the UK. Done before the guard below
         so it still works when there are no delivery stats to draw. */
      var freeSdEl = note.querySelector('.mc-ship-note__freesd');
      function syncFreeSd(cc) { if (freeSdEl) freeSdEl.hidden = !(cc === 'GB' || cc === 'IM'); }
      if (freeSdEl && sel) sel.addEventListener('change', function () { syncFreeSd(sel.value); });
      if (!dataEl || !sel) return;
      var stats; try { stats = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var ds = note.dataset;
      var ddp = (ds.ddp || '').split(','), dap = (ds.dap || '').split(',');
      var timeEl = note.querySelector('.mc-ship-note__time');
      var basisEl = note.querySelector('.mc-ship-note__basis');
      var dutyEl = note.querySelector('.mc-ship-note__duty');
      var KEY = 'mc-ship-country';

      function groupOf(cc) {
        if (cc === 'GB' || cc === 'IM') return 'uk';
        if (cc === 'US') return 'us';
        if (ddp.indexOf(cc) !== -1) return 'ddp';
        if (dap.indexOf(cc) !== -1) return 'dap';
        return 'world';
      }
      /* Regions inside a country (the USA by coast): a ballpark per region
         listed under the line, no choosing (Matt, 6 Sept). */
      var regionsEl = note.querySelector('.mc-ship-note__regions');
      function regionLabel(r) { return ds['tRegion' + r.toUpperCase()] || r; }
      function daysText(t) { return t.p50 === t.p80 ? fill(ds.tDaysAbout, { n: t.p50 }) : fill(ds.tDaysRange, { lo: t.p50, hi: t.p80 }); }
      function drawRegions(cc) {
        var rs = stats.regions && stats.regions[cc];
        if (!regionsEl) return false;
        var keys = rs ? ['E', 'C', 'W'].filter(function (k) { return rs[k]; }) : [];
        regionsEl.innerHTML = '';
        if (!keys.length) { regionsEl.hidden = true; return false; }
        var head = document.createElement('tr'), row = document.createElement('tr');
        keys.forEach(function (k) {
          var th = document.createElement('th'); th.scope = 'col'; th.textContent = regionLabel(k); head.appendChild(th);
          var td = document.createElement('td'); td.textContent = daysText(rs[k]); row.appendChild(td);
        });
        var thead = document.createElement('thead'), tbody = document.createElement('tbody');
        thead.appendChild(head); tbody.appendChild(row);
        regionsEl.appendChild(thead); regionsEl.appendChild(tbody);
        regionsEl.hidden = false;
        return true;
      }
      /* Services inside a country (the UK by Royal Mail service, 8 Sept):
         Tracked 48 and Tracked 24 from measured deliveries; Special Delivery is
         always Royal Mail's promise (Matt). Then the Priority same-day line. */
      var servicesEl = note.querySelector('.mc-ship-note__services');
      var priorityEl = note.querySelector('.mc-ship-note__priority');
      function svcDays(t) { return (t.p50 <= 1 && t.p80 <= 1 && ds.tDaysNext) ? ds.tDaysNext : daysText(t); }
      function drawServices(cc) {
        var ss = stats.services && stats.services[cc];
        if (!servicesEl) return false;
        var rows = [];
        /* £250+ UK cart: only Special Delivery is offered, so only Special
           Delivery is listed (20 Sept 2026). The server-rendered notice is the
           signal that this cart qualifies. */
        var qualifiesFreeSd = !!freeSdEl && (cc === 'GB' || cc === 'IM');
        var hasUkSvcData = !!(ss && (ss.t48 || ss.t24));
        if (!qualifiesFreeSd) {
          if (ss && ss.t48) rows.push([ds.tSvcT48, svcDays(ss.t48)]);
          if (ss && ss.t24) rows.push([ds.tSvcT24, svcDays(ss.t24)]);
        }
        if ((rows.length || (qualifiesFreeSd && hasUkSvcData)) && groupOf(cc) === 'uk' && ds.tSvcSpecialTime) rows.push([ds.tSvcSpecial, ds.tSvcSpecialTime]);
        servicesEl.innerHTML = '';
        if (!rows.length) { servicesEl.hidden = true; return false; }
        rows.forEach(function (r) {
          var li = document.createElement('li');
          var a = document.createElement('span'); a.className = 'mc-ship-note__svc-name'; a.textContent = r[0];
          var b = document.createElement('span'); b.className = 'mc-ship-note__svc-time'; b.textContent = r[1];
          li.appendChild(a); li.appendChild(b); servicesEl.appendChild(li);
        });
        servicesEl.hidden = false;
        return true;
      }
      function render(cc) {
        var name = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text : cc;
        var zone = zoneOf(cc);
        var c = stats.countries && stats.countries[cc];
        var z = stats.zones && stats.zones[zone];
        var t = c ? c.transit : (z ? z.transit : null);
        var hasRegions = drawRegions(cc);
        var hasServices = drawServices(cc);
        if (priorityEl) { priorityEl.textContent = ds.tPriority || ''; priorityEl.hidden = !(groupOf(cc) === 'uk' && ds.tPriority) || note.getAttribute('data-preorder') === '1'; }
        if (!t || !t.n) {
          timeEl.textContent = ds.tNodata || '';
          basisEl.textContent = '';
        } else {
          timeEl.textContent = (hasRegions || hasServices) ? (ds.tRegionsLead || '') : t.p50 === t.p80
            ? fill(ds.tTransitSame, { n: t.p50 })
            : fill(ds.tTransit, { lo: t.p50, hi: t.p80 });
          var place = c ? withArticle(name) : (ds['tZone' + zone.charAt(0).toUpperCase() + zone.slice(1)] || zone);
          basisEl.textContent = fill(ds.tBasis, { n: t.n, place: place, days: stats.window_days || 90 });
        }
        if (dutyEl) dutyEl.textContent = ds['g' + groupOf(cc).charAt(0).toUpperCase() + groupOf(cc).slice(1)] || '';
        syncFreeSd(cc);
        note.setAttribute('data-country', cc);
      }
      var saved = null;
      try { saved = localStorage.getItem(KEY); } catch (e) { /* private mode */ }
      if (saved && sel.querySelector('option[value="' + saved + '"]')) sel.value = saved;
      render(sel.value);
      sel.addEventListener('change', function () {
        try { localStorage.setItem(KEY, sel.value); } catch (e) { /* ignore */ }
        render(sel.value);
      });

      /* Upgrade the <select> to a search-as-you-type box (Matt, 6 Sept). The
         select keeps the value and fires change as before; this is only the UI. */
      var opts = Array.prototype.map.call(sel.options, function (o) { return { cc: o.value, name: o.text }; });
      var combo = document.createElement('div'); combo.className = 'mc-ship-note__combo';
      sel.parentNode.insertBefore(combo, sel); combo.appendChild(sel);
      var input = document.createElement('input');
      input.type = 'text'; input.className = 'mc-ship-note__input'; input.autocomplete = 'off'; input.spellcheck = false;
      input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-label', sel.previousElementSibling ? sel.previousElementSibling.textContent : 'Country');
      var list = document.createElement('ul'); list.className = 'mc-ship-note__list'; list.setAttribute('role', 'listbox'); list.hidden = true;
      combo.appendChild(input); combo.appendChild(list);
      var lab = sel.closest('label'); if (lab) lab.removeAttribute('for');
      var active = -1, shown = [];
      function nameOf(cc) { var o = opts.filter(function (x) { return x.cc === cc; })[0]; return o ? o.name : cc; }
      function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
      function choose(cc) { sel.value = cc; sel.dispatchEvent(new Event('change', { bubbles: true })); input.value = nameOf(cc); close(); }
      function show(q) {
        var needle = (q || '').trim().toLowerCase();
        /* names that START with the typed text first (so "ger" -> Germany before Algeria), then the rest */
        shown = needle ? opts.filter(function (o) { return o.name.toLowerCase().indexOf(needle) !== -1 || o.cc.toLowerCase() === needle; })
          .sort(function (a, b) { var sa = a.name.toLowerCase().indexOf(needle) === 0 ? 0 : 1, sb = b.name.toLowerCase().indexOf(needle) === 0 ? 0 : 1; return sa - sb; }) : opts;
        list.innerHTML = '';
        if (!shown.length) { var none = document.createElement('li'); none.className = 'mc-ship-note__none'; none.textContent = 'No match'; list.appendChild(none); }
        shown.slice(0, 200).forEach(function (o, i) {
          var li = document.createElement('li'); li.className = 'mc-ship-note__opt'; li.setAttribute('role', 'option'); li.textContent = o.name; li.dataset.cc = o.cc;
          li.setAttribute('aria-selected', o.cc === sel.value ? 'true' : 'false');
          li.addEventListener('mousedown', function (e) { e.preventDefault(); choose(o.cc); });
          list.appendChild(li);
        });
        list.hidden = false; input.setAttribute('aria-expanded', 'true'); active = -1;
        var cur = list.querySelector('[aria-selected="true"]'); if (cur && !needle) cur.scrollIntoView({ block: 'nearest' });
      }
      function highlight(n) {
        var items = list.querySelectorAll('.mc-ship-note__opt'); if (!items.length) return;
        active = (n + items.length) % items.length;
        items.forEach(function (el, i) { el.setAttribute('aria-selected', i === active ? 'true' : 'false'); });
        items[active].scrollIntoView({ block: 'nearest' });
      }
      input.value = nameOf(sel.value);
      sel.addEventListener('change', function () { if (document.activeElement !== input) input.value = nameOf(sel.value); });
      input.addEventListener('focus', function () { input.select(); show(''); });
      input.addEventListener('input', function () { show(input.value); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden) show(input.value); highlight(active + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
        else if (e.key === 'Enter') { e.preventDefault(); var pick = active >= 0 ? shown[active] : shown[0]; if (pick) choose(pick.cc); }
        else if (e.key === 'Escape') { input.value = nameOf(sel.value); close(); }
      });
      input.addEventListener('blur', function () { setTimeout(function () { input.value = nameOf(sel.value); close(); }, 120); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
